
"use client";
import Image from "next/image";

interface LogoAndNameProps {
  width?: number;
  height?: number;
  className?: string;
  priority?: boolean;
}

export default function LogoAndNameImage({ 
  width = 130, 
  height = 20,
  className = "",
  priority = false 
}: LogoAndNameProps) {
  return (
    <Image
      className={className}
      src="/zundoku-logo-b.svg"
      alt="Zundoku Logo"
      width={width}
      height={height}
      priority={priority}
    />
  );
}